const formatNumber = (numero: number): string => {
    //const number = Number(numero); 

    const numeroFormateado = numero.toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return numeroFormateado;
  };

export default formatNumber;